import { JSConn } from "@/utilities/js-conn";
import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "logIn",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  data() {
    return {
      email: null,
      password: null,
      dataLoaded: false,
      loadingMessage: "Loading...",
      hasFormErrors: false,
      formErrors: [],
    };
  },
  created() {
    this.dataLoaded = true;
    this.$nextTick(() => this.$refs.firstInput.select());
  },
  methods: {
    submitLogIn: function(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/work-queue";
      jsConn.formParams = {
        email: this.email,
        password: this.password,
      };
      this.$store
        .dispatch("logInUser", jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(JSConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
  },
};
